import React from "react";
/* ===================== RING LAYOUT CONFIG ===================== */

const RING_LAYOUTS = {
  3: { strokeWidth: 4.9, radii: [15.25, 9.5, 3.75] },
  4: { strokeWidth: 3, radii: [15, 11.25, 7.5, 3.75] },
  5: { strokeWidth: 3, radii: [16, 12.5, 9, 5.5, 2] },
  6: { strokeWidth: 2.1, radii: [16, 13.5, 11, 8.5, 6, 3.5, 1] },
  7: { strokeWidth: 2.1, radii: [16, 13.5, 11, 8.5, 6, 3.5, 1] },
  8: { strokeWidth: 1.8, radii: [16, 14, 12, 10, 8, 6, 4, 2] },
};

/* ===================== HELPERS ===================== */

const clamp = (v) => Math.min(Math.max(v, 0), 100);
const calculatePercentage = (value, start, end) => {
  const range = end - start;
  if (range <= 0) return 0;

  const raw = ((value - start) / range) * 100;

  const rounded = Math.round(raw + Number.EPSILON);

  return Math.min(Math.max(rounded, 0), 100);
};

const getStroke = (radius, percentage) => {
  const dash = 2 * Math.PI * radius;

  if (percentage >= 100) {
    return {
      strokeDasharray: dash,
      strokeDashoffset: 0,
    };
  }

  return {
    strokeDasharray: dash,
    strokeDashoffset: dash * (1 - percentage / 100),
  };
};

/* ===================== LESS RINGS ===================== */

const LessRings = ({ rangeData, value }) => {
  const layout = RING_LAYOUTS[rangeData.length];
  if (!layout) return null;

  const sorted = [...rangeData].sort((a, b) => b.startrange - a.startrange);

  return (
    <div
      className="activity-tracker less_rings"
      style={{ "--stroke-width": layout.strokeWidth }}
    >
      {sorted.map((item, i) => {
        const radius = layout.radii[i];
        if (!radius) return null;

        // const range = item.endrange - item.startrange || 1;
        // const pct = clamp(
        //   Math.round(((value - item.startrange) / range) * 100)
        // );
        const pct = calculatePercentage(value, item.startrange, item.endrange);

        const stroke = getStroke(radius, pct);

        return (
          <svg key={i} className="ring" viewBox="0 0 36 36">
            <circle className="ring-bg" cx="18" cy="18" r={radius} />
            <circle
              className="ring-progress"
              cx="18"
              cy="18"
              r={radius}
              style={{
                stroke: item.colorcode,
                strokeWidth: layout.strokeWidth,
                ...stroke,
              }}
            />
          </svg>
        );
      })}
    </div>
  );
};

/* ===================== MORE RINGS ===================== */

const MoreRings = ({ rangeData, value }) => {
  const ringCount = Math.min(rangeData.length, 8);
  const layout = RING_LAYOUTS[ringCount];
  if (!layout) return null;

  const sorted = [...rangeData].sort((a, b) => a.startrange - b.startrange);

  return (
    <div
      className="activity-tracker more_rings"
      style={{ "--stroke-width": layout.strokeWidth }}
    >
      {layout.radii.map((radius, i) => {
        const item = sorted[i];

        let pct = 0;
        let color = "#d3d3d3";

        if (item) {
          // const range = item.endrange - item.startrange || 1;
          // pct = clamp(Math.round(((value - item.startrange) / range) * 100));
          pct = calculatePercentage(value, item.startrange, item.endrange);

          color = item.colorcode;
        }

        const stroke = getStroke(radius, pct);

        return (
          <svg key={i} className="ring" viewBox="0 0 36 36">
            <circle className="ring-bg" cx="18" cy="18" r={radius} />
            <circle
              className="ring-progress"
              cx="18"
              cy="18"
              r={radius}
              style={{
                stroke: color,
                strokeWidth: layout.strokeWidth,
                ...stroke,
              }}
            />
          </svg>
        );
      })}
    </div>
  );
};

/* ===================== MAIN COMPONENT ===================== */

const ScorecardCircle = ({ rangeData = [], balancescorecardvalue }) => {
  const value = Number(balancescorecardvalue);
  const hasRings = rangeData.length > 0;
  return (
    <div className="scorecard-circle-wrapper">
      {/* ================= RINGS ================= */}

      {hasRings ? (
        rangeData.length > 5 ? (
          <MoreRings rangeData={rangeData} value={value} />
        ) : (
          <LessRings rangeData={rangeData} value={value} />
        )
      ) : (
        <div className="ring-placeholder" />
      )}

      {/* ================= TOOLTIP ================= */}
      <div className="scorecard_range_tooltip">
        <ul>
          {rangeData.map((item, index) => (
            <li key={index}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div
                    className="scorerange_color"
                    style={{ backgroundColor: item.colorcode }}
                  />
                  <div className="scorerangetext">{item.balscoretitle}</div>
                </div>
                <div className="scorerangevalue">
                  {item.startrange} - {item.endrange}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ScorecardCircle;
